import { createApp } from "vue";
import CriticalFunc from "@/components/CriticalFunc.vue";
import router from "@/router"; // Import your router

const showModal = (message, targetUrl) => {
  const mountPoint = document.createElement("div");
  document.body.appendChild(mountPoint);

  const modalApp = createApp(CriticalFunc, {
    message,
    targetUrl,
    onClose: () => {
      modalApp.unmount();
      mountPoint.remove();
    },
  });

  modalApp.use(router); // Add router to modal instance
  modalApp.mount(mountPoint);
};

export default {
  install: (app) => {
    app.config.globalProperties.$showModal = showModal;
    app.provide("showModal", showModal);
  },
};
